import { createClient } from "contentful";

export const client = createClient({
  space: "01r95exi1rjj",
  accessToken: "Fn4viFejjSE1DKMSJIJpTdbBR-IQnAjtZIBIh8idOeg",
});
